import React, { InputHTMLAttributes, ReactChild } from 'react'
import CheckMarkIcon from '../icons/CheckMark'
import './styles.ts'
import { Checkbox, CustomCheckbox, Input, Label, LabelWrapper } from './styles'
import { P } from '../../styles/Elements'

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string
  disabled?: boolean
  label?: ReactChild
  onCheck?: () => void
  checked?: boolean
}

const InputCheckbox = ({
  disabled = false,
  label,
  onCheck,
  checked,
  ...props
}: CheckboxProps) => {
  const isChecked = typeof checked === 'boolean' ? checked : !!props.value
  return (
    <Checkbox className="checkbox">
      <Label htmlFor={props.name}>
        <Input
          disabled={disabled}
          id={props.name}
          type="checkbox"
          checked={isChecked}
          {...props}
          {...(onCheck && { onChange: onCheck })}
        />
        <CustomCheckbox active={isChecked} disabled={disabled}>
          <CheckMarkIcon />
        </CustomCheckbox>
      </Label>
      {!!label && (
        <LabelWrapper>
          <P>{label}</P>
        </LabelWrapper>
      )}
    </Checkbox>
  )
}

export default InputCheckbox
